import Axios from "axios";
import Cookies from "js-cookie";

const client = Axios.create();

client.interceptors.request.use(
  (config) => {
    if (config.url?.includes("login")) {
      return config;
    }

    const token = Cookies.get(window.__env.AUTH_TOKEN_NAME || "get-move-token");

    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

client.interceptors.response.use(
  (res) => res,
  (err) => {
    const res = err.response;
    if (
      res &&
      !res.config.url.includes("login") &&
      !res.config.url.includes("token")
    ) {
      // 423 = gestionale bloccato dal Superadmin: logout e messaggio al login.
      if (res.status === 423) {
        Cookies.remove(window.__env.AUTH_TOKEN_NAME || "get-move-token");
        Cookies.remove(window.__env.AUTH_USER_NAME || "get-move-user");
        sessionStorage.setItem(
          "platform-lock-message",
          res.data?.error ||
            "L'accesso al gestionale è temporaneamente sospeso."
        );
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      } else if ([401, 403].includes(res.status)) {
        Cookies.remove(window.__env.AUTH_TOKEN_NAME || "get-move-token");
        Cookies.remove(window.__env.AUTH_USER_NAME || "get-move-user");
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export default client;
